import React, {useContext, useEffect, useState} from 'react'
import {Button, Divider, message, Modal, Popconfirm, Select, TreeSelect} from "antd"
import UserContext from "../../context/UserContext"
import {addUser, getListExtensions} from "../../../../services/api/apiUser"
import parseToken from "../../../../helpers/parseToken"
import SelectSearchDouble from "../actions/SelectSearchDouble"
import {generatePasswordRandom} from "../../../../helpers/generatePassword"

function AddUserForm(props) {
    const decodeToken = parseToken()
    const {isModalVisible, toggleModal} = props
    const {
        treeData,
        getUsers,
        roles,
        tenants,
        getExtensions,
        listDepartment,
        listCalloutId
    } = useContext(UserContext)
    const [item, setItemUser] = useState({status: 1})
    const [validate, setValidate] = useState({})
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [showPass] = useState(true)
    const [listExtensions, setListExtensions] = useState([])

    const _handleChange = (value) => {
        setItemUser({
            ...item,
            deptId: value,
            deptName: listDepartment.find(item => item.deptId === value).deptName
        })

        delete validate['deptName']
    }

    const _onGeneratePassword = () => {
        setItemUser({
            ...item,
            password: generatePasswordRandom(6)
        })
        delete validate['password']
    }

    const _handleChangeRoleId = (value) => {
        setItemUser({
            ...item,
            roleIdList: value
        })
        delete validate['roleIdList']
    }

    const _handleChangePassword = (e) => {
        const {value} = e.target
        setItemUser({
            ...item,
            password: value
        })
        delete validate['password']
    }

    const _handleChangeName = (e) => {
        const {value} = e.target

        setItemUser({
            ...item,
            fullName: value
        })
        delete validate['fullName']
    }

    const _handleChangeUserName = (e) => {
        const {value} = e.target

        setItemUser({
            ...item,
            userName: value
        })
        delete validate['userName']
    }

    const _handleChangeEmail = (e) => {
        const {value} = e.target
        if (value.trim()) {
            const emailIsValid = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value)
            if (emailIsValid) {
                setItemUser({
                    ...item,
                    userName: ''
                })
                delete validate['email']
                setError('')
            } else {
                setValidate({
                    ...validate,
                    email: 'Email phải đúng định dạng'
                })
            }

            setItemUser({
                ...item,
                userName: emailIsValid ? value.split("@")[0] : "",
                email: value
            })
        } else {
            setItemUser({
                ...item,
                userName: '',
                email: value
            })

            delete validate['email']
        }
    }

    const _handleChangePhone = (e) => {
        const {value} = e.target

        const regexPhone = /^[0-9]\d*$/
        if (value.trim()) {
            if (!regexPhone.test(value) || (value.indexOf('0') === 0 && value.length !== 10) || (value.indexOf('0') !== 0 && value.length !== 9)) {
                setValidate({
                    ...validate,
                    phone: 'Số điện thoại không đúng định dạng.'
                })
            } else {
                delete validate['phone']
            }
        } else {
            setValidate({
                ...validate,
                phone: 'Phone là bắt buộc'
            })
        }

        setItemUser({
            ...item,
            phone: value
        })
        setError('')
    }

    const _handleChangeStatus = (value) => {
        setItemUser({
            ...item,
            status: value
        })
    }

    const _handleChangeTenants = (value) => {
        setItemUser({
            ...item,
            tenantId: value || tenants[0].id,
            extension: ''
        })
        delete validate['tenantId']
    }

    const _handleChangeExtension = (value) => {
        setItemUser({
            ...item,
            extension: value || tenants[0].extension
        })
        delete validate['extension']
    }

    const _handleChangeCallout = (name, value) => {
        setItemUser({
            ...item,
            calloutId: value
        })
    }

    const _onAddUser = async () => {
        setLoading(true)

        const validateCheck = _validateData()

        if (Object.keys(validateCheck).length > 0) {
            setLoading(false)
            return false
        }

        try {
            const payload = {
                userId: item.userId,
                userName: item.userName,
                email: item.email || 'alogiare.com@gmail.com',
                phone: item.phone,
                fullName: item.fullName,
                roleIdList: item.roleIdList,
                deptId: item.deptId,
                deptName: item.deptName,
                status: item.status,
                tenantId: item.tenantId,
                extension: item.extension,
                calloutId: item.calloutId,
                password: item.password
            }
            const response = await addUser(payload, decodeToken.sub)

            const {success, error_message} = response

            if (success !== '1') {
                setLoading(false)

                return message.error(error_message)
            }

            setLoading(false)
            message.success("Thêm mới thành công.")
            getExtensions()
        } catch (e) {
            setLoading(false)
            message.error(e.message)
        }
    }

    const _validateData = () => {
        let validateForm = {}
        const regexPhone = /^[0-9]\d*$/

        if (item.fullName === undefined || item.fullName.trim() === '') {
            Object.assign(validateForm, {fullName: 'Họ và tên là bắt buộc'})
        }

        if (item.userName === undefined || item.userName === '') {
            Object.assign(validateForm, {userName: 'userName là bắt buộc'})
        }

        if (item.email) {
            if (!(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(item.email))) {
                Object.assign(validateForm, {email: 'Email phải đúng định dạng'})
            }
        }

        if (item.phone !== undefined && item.phone !== '') {
            if (!regexPhone.test(item.phone) || (item.phone.indexOf('0') === 0 && item.phone.length !== 10) || (item.phone.indexOf('0') !== 0 && item.phone.length !== 9)) {
                Object.assign(validateForm, {phone: 'Số điện thoại không đúng định dạng.'})
            }
        }

        if (item.password === undefined || item.password === '' || item.password.length < 6) {
            Object.assign(validateForm, {password: 'Password là bắt buộc và lớn hơn 6 ký tự'})
        }

        if (item.tenantId === undefined || item.tenantId === '') {
            Object.assign(validateForm, {tenantId: 'Công ty là bắt buộc'})
        }

        if (item.deptName === undefined || item.deptName === '') {
            Object.assign(validateForm, {deptName: 'Phòng ban là bắt buộc'})
        }

        if (item.roleIdList === undefined || item.roleIdList === '') {
            Object.assign(validateForm, {roleIdList: 'Danh sách quyền là bắt buộc'})
        }

        if (item.extension === undefined || item.extension === '') {
            Object.assign(validateForm, {extension: 'Số mở rộng là bắt buộc'})
        }

        setValidate(validateForm)

        return validateForm
    }

    const _getExtensions = async () => {
        try {
            const response = await getListExtensions({tenantId: item.tenantId}, decodeToken.sub)
            const {success, data} = response
            if (parseInt(success) !== 1) {
                return
            }
            const _extensions = data.map(itemM => {
                return {
                    name: itemM.extension,
                    value: itemM.extension,
                    status: itemM.status
                }
            })
            setListExtensions([..._extensions])
        } catch (e) {

        }
    }

    const onSave = async () => {
        const response = await _onAddUser()

        if (response !== false) {
            if (typeof getUsers === 'function') {
                await getUsers()
            }
            handleCancel()
        }
    }

    const handleCancel = () => {
        toggleModal(false)
        _resetCustomerInfo()
    }

    const onSaveAndNew = async () => {
        const response = await _onAddUser()
        if (response !== false) {
            if (typeof getUsers === 'function') {
                await getUsers()
            }
            await _resetCustomerInfo()
        }
    }

    const _resetCustomerInfo = () => {
        setItemUser({})
    }

    useEffect(() => {
        _getExtensions()
        // eslint-disable-next-line
    }, [item.tenantId])

    useEffect(() => {
        if (isModalVisible) {
            setItemUser({
                ...item,
                password: generatePasswordRandom(6)
            })
        }
        // eslint-disable-next-line
    }, [isModalVisible])

    return (
        <div className="CustomerForm">
            <Modal
                title="Thêm mới User"
                className="ModalCustom2 FormAdd"
                maskClosable={false}
                visible={isModalVisible}
                footer={[
                    <div className="Actions d-flex justify-content-end align-items-center">
                        <Popconfirm placement="top" title="Bạn chắc chắn muốn thoát?" onConfirm={handleCancel}
                                    okText="Yes" cancelText="No">
                            <Button key="back" type="link" disable={loading}>
                                Cancel
                            </Button>
                        </Popconfirm>
                        <Popconfirm placement="top" title="Bạn chắc chắn muốn lưu và tạo mới User?"
                                    onConfirm={onSaveAndNew} okText="Yes" cancelText="No">
                            <Button key="submit2" loading={loading}>
                                Save & New
                            </Button>
                        </Popconfirm>
                        <Popconfirm placement="top" title="Bạn chắc chắn muốn lưu User?" onConfirm={onSave} okText="Yes"
                                    cancelText="No">
                            <Button key="submit" type="primary" loading={loading}>
                                Save
                            </Button>
                        </Popconfirm>
                    </div>
                ]}
            >
                <div className="FormEdit FormAddNew">
                    <Divider orientation="left" orientationMargin="0">Thông tin tin chung</Divider>
                    <div className="row">
                        <div className={`FieldItem ${validate.fullName && 'error'} col-md-6`}>
                            <label className="Label" htmlFor="fullName">
                                Họ và tên
                                <span className="Required">*</span>
                            </label>
                            <input id="fullName" type="text" value={item.fullName || ''} onChange={_handleChangeName}/>
                            {
                                validate.fullName && <span className="Error text-danger">{validate.fullName}</span>
                            }
                        </div>
                        <div className={`FieldItem ${validate.email && 'error'} col-md-6`}>
                            <label className="Label" htmlFor="email">
                                Email
                            </label>
                            <input id="email" name="email" type="text" value={item.email || ''}
                                   onChange={_handleChangeEmail}/>
                            {
                                validate.email && <span className="Error text-danger">{validate.email}</span>
                            }
                        </div>
                        <div className={`FieldItem ${validate.userName && 'error'} col-md-6`}>
                            <label className="Label" htmlFor="userName">
                                Username
                                <span className="Required">*</span>
                            </label>
                            <input
                                id="userName"
                                type={'text'}
                                value={item.userName || ''}
                                onChange={_handleChangeUserName}
                            />
                            {
                                validate.userName && <span className="Error text-danger">{validate.userName}</span>
                            }
                        </div>
                        <div className={`FieldItem ${validate.password && 'error'} col-md-6`}>
                            <label className="Label" htmlFor="password">
                                Mật khẩu
                                <span className="Required">*</span>
                            </label>
                            <div className="generate-password">
                                <input
                                    id="password"
                                    type={showPass ? 'text' : 'password'}
                                    value={item.password || ''}
                                    onChange={_handleChangePassword}
                                />
                                <Button type="primary" onClick={_onGeneratePassword}>Generate</Button>
                            </div>
                            {
                                validate.password && <span className="Error text-danger">{validate.password}</span>
                            }
                        </div>
                        <div className={`FieldItem ${validate.tenantId && 'error'} col-md-6`}>
                            <label className="Label" htmlFor="tenants">
                                Công ty
                                <span className="Required">*</span>
                            </label>
                            <Select
                                showSearch
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                optionFilterProp="children"
                                onChange={_handleChangeTenants}
                                defaultValue={item.tenantId}
                                placeholder="Please select"
                            >
                                {!!tenants && tenants.length > 0 && tenants.map((item) => (
                                    <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>
                                ))}
                            </Select>
                            {
                                validate.tenantId && <span className="Error text-danger">{validate.tenantId}</span>
                            }
                        </div>
                        <div className={`FieldItem ${validate.deptName && 'error'} col-md-6`}>
                            <label className="Label" htmlFor="name">
                                Phòng ban
                                <span className="Required">*</span>
                            </label>
                            <TreeSelect
                                style={{width: '100%'}}
                                dropdownStyle={{maxHeight: 400, overflow: 'auto'}}
                                treeData={treeData}
                                placeholder="Please select"
                                treeDefaultExpandAll
                                onChange={_handleChange}
                                showSearch
                                filterTreeNode={(search, item) => {
                                    return item.title.toLowerCase().indexOf(search.toLowerCase()) >= 0;
                                }}
                            />
                            {
                                validate.deptName && <span className="Error text-danger">{validate.deptName}</span>
                            }
                        </div>
                        <div className={`FieldItem ${validate.phone && 'error'} col-md-6`}>
                            <label className="Label" htmlFor="phone">
                                Phone
                            </label>
                            <input id="phone" type="text" value={item.phone || ''} onChange={_handleChangePhone}/>
                            {
                                validate.phone && <span className="Error text-danger">{validate.phone}</span>
                            }
                        </div>
                        <div className="FieldItem col-md-6">
                            <label className="Label" htmlFor="name">
                                Trạng thái
                            </label>
                            <Select
                                onChange={_handleChangeStatus}
                                defaultValue={item.status}
                                placeholder="Please select"
                            >
                                <Select.Option value={1}>Active</Select.Option>
                                <Select.Option value={0}>Disable</Select.Option>
                            </Select>
                        </div>
                        <div className={`FieldItem ${validate.roleIdList && 'error'} col-md-12`}>
                            <label className="Label" htmlFor="name">
                                Danh sách quyền
                                <span className="Required">*</span>
                            </label>
                            <Select
                                showSearch
                                filterOption={(input, option) =>
                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                optionFilterProp="children"
                                className="SelectMulti"
                                mode="multiple"
                                allowClear
                                style={{width: '100%'}}
                                placeholder="Please select"
                                onChange={_handleChangeRoleId}
                            >
                                {
                                    !!roles && roles.length > 0 && roles.map(item => {
                                        return <Select.Option key={item.roleId}
                                                              value={item.roleId}>{item.roleName}</Select.Option>
                                    })
                                }
                            </Select>
                            {
                                validate.roleIdList && <span className="Error text-danger">{validate.roleIdList}</span>
                            }
                        </div>
                    </div>
                    <Divider orientation="left" orientationMargin="0">Tùy chọn cấu hình tổng đài</Divider>
                    <div className="row">
                        <div className={`FieldItem ${validate.extension && 'error'} col-md-6`}>
                            <label className="Label" htmlFor="extension">
                                Gán số extension
                                <span className="Required">*</span>
                            </label>
                            <Select
                                showSearch
                                onChange={_handleChangeExtension}
                                value={item.extension}
                                placeholder="Please select"
                            >
                                {listExtensions && listExtensions?.length > 0 && listExtensions.map((item) => (
                                    <Select.Option key={item.vaue} value={item.value} disabled={item.status === 1}>
                                        {item.name}
                                    </Select.Option>
                                ))}
                            </Select>
                            {
                                validate.extension && <span className="Error text-danger">{validate.extension}</span>
                            }
                        </div>
                        <div className="FieldItem col-md-6">
                            <SelectSearchDouble
                                name="calloutId"
                                value={item.calloutId}
                                onChange={_handleChangeCallout}
                                label="Nhóm gọi ra"
                                listSelect={listCalloutId}
                            />
                        </div>
                    </div>
                    {error && <div className="text-danger">{error}</div>}
                </div>
            </Modal>
        </div>
    )
}

export default AddUserForm
